// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.format1-report {
    width: 90%;
    margin: auto;
    font-family: Arial, sans-serif;
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .report-header {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .student-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap; /* Ensure wrapping on smaller screens */
  }
  
  .student-photo {
    flex: 1 1;
    display: flex;
    justify-content: end;
    margin-bottom: 10px; /* Add spacing on smaller screens */
  }
  
  .student-image {
    width: 150px;
    height: 150px;
    border-radius: 10px;
  }
  
  .student-details {
    flex: 2 1;
    text-align: left;
  }
  
  .report-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .report-table th, .report-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .report-table th {
    background-color: #4CAF50;
    color: white;
  }
  
  .signatures {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    flex-wrap: wrap; /* Ensure wrapping on small screens */
  }
  
  .print-button {
    background-color: #4CAF50;
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    margin-top: 10px;
    width: 8%; /* Full width on mobile */
    max-height: '30px';
  }
  
  .print-button:hover {
    background-color: #45a049;
  }
  
  /* Responsive Styling */
  @media (max-width: 768px) {
    .student-info {
      flex-direction: column; /* Stack items vertically on small screens */
      align-items: center;
    }
  
    .student-details {
      text-align: center;
    }
  
    .signatures {
      flex-direction: column; /* Stack signatures on small screens */
      align-items: center;
    }
  }

  
  `, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/singleExamReports.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe,EAAE,uCAAuC;EAC1D;;EAEA;IACE,SAAO;IACP,aAAa;IACb,oBAAoB;IACpB,mBAAmB,EAAE,mCAAmC;EAC1D;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe,EAAE,qCAAqC;EACxD;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,SAAS,EAAE,yBAAyB;IACpC,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,uBAAuB;EACvB;IACE;MACE,sBAAsB,EAAE,4CAA4C;MACpE,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,sBAAsB,EAAE,sCAAsC;MAC9D,mBAAmB;IACrB;EACF","sourcesContent":[".format1-report {\n    width: 90%;\n    margin: auto;\n    font-family: Arial, sans-serif;\n    background-color: #f9f9f9;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .report-header {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  .student-info {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    flex-wrap: wrap; /* Ensure wrapping on smaller screens */\n  }\n  \n  .student-photo {\n    flex: 1;\n    display: flex;\n    justify-content: end;\n    margin-bottom: 10px; /* Add spacing on smaller screens */\n  }\n  \n  .student-image {\n    width: 150px;\n    height: 150px;\n    border-radius: 10px;\n  }\n  \n  .student-details {\n    flex: 2;\n    text-align: left;\n  }\n  \n  .report-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n  }\n  \n  .report-table th, .report-table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: center;\n  }\n  \n  .report-table th {\n    background-color: #4CAF50;\n    color: white;\n  }\n  \n  .signatures {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n    flex-wrap: wrap; /* Ensure wrapping on small screens */\n  }\n  \n  .print-button {\n    background-color: #4CAF50;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    margin-top: 10px;\n    width: 8%; /* Full width on mobile */\n    max-height: '30px';\n  }\n  \n  .print-button:hover {\n    background-color: #45a049;\n  }\n  \n  /* Responsive Styling */\n  @media (max-width: 768px) {\n    .student-info {\n      flex-direction: column; /* Stack items vertically on small screens */\n      align-items: center;\n    }\n  \n    .student-details {\n      text-align: center;\n    }\n  \n    .signatures {\n      flex-direction: column; /* Stack signatures on small screens */\n      align-items: center;\n    }\n  }\n\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
